import * as React from "react";
import notFound from "@assets/svg/404.svg";
import { Link } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        maxHeight: "100vh",
        minWidth: "100vw",
        maxWidth: "100vw",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        left: 0,
        flexDirection: "column",
      }}
    >
      <img src={notFound} width={200} alt="notfound" />
      <div style={{ maxWidth: 300, marginTop: 40, textAlign: "center" }}>
        <h5>
          A página que você acessou não existe, <Link to="/">clique aqui</Link> para retornar a tela inicial
        </h5>
      </div>
    </div>
  );
};

export default NotFoundPage;
